module.exports = "/assets/data/041d97360d915e70d9905f3f75d9cbcc-WR2.data.json";